import gql from 'graphql-tag'

export const fetchUserProfile = user_id => ({
	query: gql`
		query ($user_id: bigint!) {
			user: users_by_pk(id: $user_id) {
				name
				lastname
				email
				mobile
				phone
				country_id
				rol_id
				role {
					rol
				}
				office_id
				office: organizations_office {
					office_name
				}
				team: organizations_team {
					team_name
				}
				dni
				address
				address_state_id
				address_zipcode
			}
		}
	`,
	update: data => ({
		...data.user,
		rol: data.user.role.rol,
		office: data.user.office ? data.user.office.office_name : '',
		team: data.user.team ? data.user.team.team_name : ''
	}),
	variables: { user_id }
})
